import { render, staticRenderFns } from "./productMultiattribute.vue?vue&type=template&id=211c1f76&scoped=true&"
import script from "./productMultiattribute.vue?vue&type=script&lang=js&"
export * from "./productMultiattribute.vue?vue&type=script&lang=js&"
import style0 from "./productMultiattribute.vue?vue&type=style&index=0&id=211c1f76&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211c1f76",
  null
  
)

export default component.exports